import React, { useEffect, useState } from 'react';
import MessageErreur, {
  classeChampEnErreur,
} from '../../../UI/MessageErreur/MessageErreur';
import { schemaModificationTypeDeCapteur } from '../../../../services/schemas/sensorType';
import {
  validerFormulaire,
  messageDuChamp,
} from '../../../../services/schemas/validerFormulaire';

import AccesRestreins from '../../../../hoc/AccesRestreins/AccesRestreins';
import AttenteRequete from '../../../../hoc/AttenteRequete/AttenteRequete';
import AffichageImage from '../../../UI/AffichageImage/AffichageImage';
import AjouterImageTypeCapteur from '../AjouterImageTypeCapteur/AjouterImageTypeCapteur';

import { checkMot } from '../../../../ressources/functionJS/checkMot';
import { confirmeOnClick } from '../../../../ressources/functionJS/confirmeOnClick';
import * as privilege from '../../../../ressources/glossaires/glossaire_privileges';
import * as requestType from '../../../../ressources/glossaires/glossaire_requetes';

import { BiEditAlt, RiDeleteBin2Line, RiMailSendFill } from 'react-icons/all';
import { BiErrorCircle } from 'react-icons/bi';
import { IoIosCloseCircleOutline } from 'react-icons/io';
import * as glossaire_affichage_type_capteur from '../../../../ressources/glossaires/glossaire_affichage_type_capteur';
import * as s from '../../../../ressources/StyleGlobal/StyleGlobal';
import styles from './ProfilSensorType.module.scss';

// ...existing imports...

const ProfilSensorType = ({ InfoSelect, reqModifier, reqSupprimer }) => {
  // Separate state management with useState hooks
  const [showModal, setShowModal] = useState(false);
  const [sensorTypeName, setSensorTypeName] = useState(
    InfoSelect?.sensor_type_name || ''
  );
  const [sensorTypeDisplay, setSensorTypeDisplay] = useState(
    InfoSelect?.sensor_type_display || ''
  );
  const [showModifyForm, setShowModifyForm] = useState(false);
  const [erreurs, setErreurs] = useState({});

  // Update state when InfoSelect changes
  useEffect(() => {
    if (InfoSelect) {
      setSensorTypeName(InfoSelect.sensor_type_name);
      setSensorTypeDisplay(InfoSelect.sensor_type_display);
      setShowModifyForm(false);
    }
  }, [InfoSelect]);

  // Event handlers
  const handleSensorTypeNameChange = (event) => {
    setSensorTypeName(event.target.value);
  };

  const handleSensorTypeDisplayChange = (event) => {
    setSensorTypeDisplay(event.target.value);
  };

  const handleModifySubmit = () => {
    // Même remarque qu'à la création : l'action Redux assemble la charge
    // utile à partir de ces arguments, on valide donc sa forme ici.
    const { valide, donnees, erreurs: erreursValidation } = validerFormulaire(
      schemaModificationTypeDeCapteur,
      {
        sensor_type_id: InfoSelect.sensor_type_id,
        sensor_type_name: sensorTypeName,
        sensor_type_display: sensorTypeDisplay,
      }
    );
    setErreurs(erreursValidation);
    if (!valide) {
      return;
    }

    reqModifier(
      donnees.sensor_type_id,
      donnees.sensor_type_name,
      donnees.sensor_type_display
    );
  };

  const renderButtons = () => {
    if (showModifyForm) {
      return (
        <>
          <button
            className={styles.btM}
            onClick={() => setShowModifyForm(false)}
          >
            <BiEditAlt size={24} />
            {checkMot('annuler')}
          </button>
          <AttenteRequete
            request_type={requestType.modification_d_un_sensor_type}
            str={checkMot('modification_en_cour')}
          >
            <button className={styles.btF} onClick={handleModifySubmit}>
              <RiMailSendFill size={24} />
              {checkMot('envoi_modification')}
            </button>
          </AttenteRequete>
        </>
      );
    }

    return (
      <>
        <AccesRestreins numPrivilege={privilege.modifier_des_sensor_types}>
          <button
            className={styles.btM}
            onClick={() => setShowModifyForm(true)}
          >
            <BiEditAlt size={24} />
            {checkMot('modifier_sensor_type')}
          </button>
        </AccesRestreins>
        <AccesRestreins numPrivilege={privilege.supprimer_des_sensor_types}>
          <AttenteRequete
            request_type={requestType.suppression_d_un_sensor_type}
            str={checkMot('suppression_en_cour')}
          >
            <button
              className={styles.btF}
              onClick={() =>
                confirmeOnClick(
                  checkMot('voulez_vous_vraiment_supprimer_ce_type_de_capteur'),
                  () => reqSupprimer(parseInt(InfoSelect.sensor_type_id))
                )
              }
            >
              <RiDeleteBin2Line size={24} />
              {checkMot('supprimer_sensor_type')}
            </button>
          </AttenteRequete>
        </AccesRestreins>
        <br />
        <AccesRestreins numPrivilege={privilege.modifier_des_sensor_types}>
          {showModal ? (
            <div style={{ border: 'solid black 1px' }}>
              <span onClick={() => setShowModal(false)}>
                <IoIosCloseCircleOutline size={40} />
              </span>
              <AjouterImageTypeCapteur
                sensor_type_id={InfoSelect.sensor_type_id}
              />
            </div>
          ) : (
            <button className={styles.btM} onClick={() => setShowModal(true)}>
              <BiEditAlt size={24} />
              {checkMot('modifier_image_de_type_capteur')}
            </button>
          )}
        </AccesRestreins>
      </>
    );
  };

  if (!InfoSelect) {
    return checkMot('selectionne_une_sensor_type');
  }

  return (
    <div className={styles.profil}>
      <div className={styles.divs}>
        {InfoSelect.sensor_type_path_image ? (
          <AffichageImage
            ajoutClass={styles.img}
            src={InfoSelect.sensor_type_path_image}
            alt={'sensor_type_path_image'}
          />
        ) : (
          <div className={styles.divs}>
            <BiErrorCircle size={50} /> aucune image de type de capteur{' '}
          </div>
        )}
      </div>

      <span className={styles.span}>{checkMot('sensori_d')}</span>
      <br />
      <input
        className={styles.InputReadOnly}
        value={InfoSelect.sensor_type_id}
        readOnly
      />
      <br />

      <span className={styles.span}>{checkMot('sensor_type_name')}</span>
      <br />
      <input
        className={[
          showModifyForm ? styles.Input : styles.InputReadOnly,
          messageDuChamp(erreurs, 'sensor_type_name') ? classeChampEnErreur : '',
        ].join(' ')}
        onChange={handleSensorTypeNameChange}
        placeholder={InfoSelect.sensor_type_name}
        value={sensorTypeName}
        readOnly={!showModifyForm}
      />
      <MessageErreur cle={messageDuChamp(erreurs, 'sensor_type_name')} />
      <br />

      <span className={styles.span}>{checkMot('sensor_type_display')}</span>
      <br />
      <select
        onChange={handleSensorTypeDisplayChange}
        value={sensorTypeDisplay}
        disabled={!showModifyForm}
        className={[
          s.custom_select,
          showModifyForm ? styles.Input : styles.InputReadOnly,
        ].join(' ')}
      >
        {Object.entries(glossaire_affichage_type_capteur).map(
          ([key, value]) => (
            <option key={key} value={value}>
              {checkMot(value)}
            </option>
          )
        )}
      </select>
      <br />

      {renderButtons()}
    </div>
  );
};

export default ProfilSensorType;
